import React, { Component } from "react";

import {
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CInputGroupAppend,
  CSelect,
  CCollapse
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import ImgNoData from "../../../assets/imgs/graduation.svg";
import Breadcrumb from "../../../components/Breadcrumb";
import Interface from "../../../components/Interface";
import Loading from "../../../components/Loading/index";
import ProtectedRoute from "../../../components/ProtectedRoute";
import Widgets from "../../../components/Widgets/Widgets";
import URL from "../../../config/api";
import "./styles.css";
import axios from "../../../config/axios";

class DigitalBooksList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // dashboard: {
      //   cards: {},
      //   schedule: null,
      //   today: null,
      //   classrooms: [],
      //   rooms: [],
      //   trailActivities: []
      // },
      primaryColor: null,
      secondaryColor: null,
      books: null,
      grayColor: null,
      // disciplines: [],
      discipline: null,
      book: null,
      bookLos: [],
      chapterSelected: null,
      abilitySelected: null,
      // widget: false,
      iframe: false,
      contentId: null,
      contentName: null,
      item_id: null,
      loading: false,
      // selectedOption: null,
      word: ""
    };
  }

  getAbilities = () => {
    let abilities = this.state.book
      ?.filter(item => item.chapter === this.state.chapterSelected)
      ?.map(item => item.abilities);
    if (abilities !== undefined) {
      return abilities[0];
    }
  };

  // getAbilities = () => {
  //   let abilities = this.state.book?.abilities?.map(
  //     ability =>
  //       // if (ability.chapter_id === this.state.chapterSelected) {
  //       ability
  //     // }
  //   );
  //   return abilities;
  // };

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  removeDuplicates(array) {
    const uniqueArray = array.reduce((accumulator, current) => {
      const existingItem = accumulator.find(
        item => item.code === current.code && item.code !== "0"
      );
      if (!existingItem) {
        accumulator.push(current);
      }
      return accumulator;
    }, []);
    return uniqueArray;
  }

  componentDidMount() {
    const id = this.props.general.active_roles.group_id;

    if (id !== 39 && id !== 71) {
      axios
        .get(`${URL.api}classification/discipline/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(disciplineGet => {
          this.setState({
            // disciplines: disciplineGet.data.data
          });
        });

      axios
        .get(`${URL.api}access/group/singleView/${id}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(respmodule => {
          this.setState(() => ({
            primaryColor: respmodule.data.data.group.primary,
            secondaryColor: respmodule.data.data.group.secondary,
            grayColor: respmodule.data.data.group.primary_grey
          }));
        });
    } else {
      axios
        .get(`${URL.api}tool/digitalbooks/list`, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          this.setState({
            books: this.removeDuplicates(resp.data.digitalBooks)
          });

          if (this.props.location.state.livro_code) {
            this.setState({
              // eslint-disable-next-line react/no-access-state-in-setstate
              book: this.state.books.filter(
                item => item.code === this.props.location.state.livro_code
              )
            });

            this.getBook(this.props.location.state.livro_code);
          }
        });
    }
  }

  getBook(bookCode) {
    axios
      .get(`${URL.api}tool/digitalbooks/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` },
        params: { code: bookCode }
      })
      .then(resp => {
        // this.setState({
        //   books: this.removeDuplicates(resp.data.digitalBooks)
        // });
        this.setState({
          book: resp.data.digitalBooks,
          chapterSelected: resp.data.digitalBooks[0]?.chapter
          // selectedOption: resp.data.digitalBooks[0]?.code
        });
        this.loadLos();
      });
  }

  loadLos() {
    this.setState({
      bookLos: [],
      loading: true
    });

    const livrosLos = this.state.book.map(item => {
      item.abilities?.map(e => {
        e.abilities_los.map(l => {
          axios
            .get(`${URL.api}content/los/singleView/${l.lo_id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              let aux = {
                ability_id: e.ability_id,
                type_id: 1,
                type_color: "danger",
                type_icon: "graduation-cap",
                title: resp.data.data?.name,
                name: resp.data.data?.name,
                id: resp.data.data?.id,
                subtitle: "Aula",
                chapter: item.chapter
              };
              this.setState(prevState => ({
                bookLos: [...prevState.bookLos, aux]
              }));
            });
          this.setState({ loading: false });
        });
      });
    });
  }

  openItem = item => {
    window.open(`/content/view/${item.id}?title=${item.title}`, "_blank");
  };

  getBorder(item) {
    if (item.activity_percentage) return "light";
    if (Date.parse(item.activity_end) < Date.now()) return "danger";
    return "primary";
  }

  handleSearchChange = e => {
    const searchTerm = e.target.value;
    // Implemente aqui a lógica de pesquisa de acordo com suas necessidades
    // Pode ser uma filtragem dos livros com base no termo de pesquisa
    // Atualize o estado conforme necessário
    this.setState({ word: searchTerm });
  };

  handleSearchClick = () => {
    this.props.history.push({
      pathname: "/content/list/1",
      state: { word: this.state.word }
    });
  };

  render() {
    const root = document.documentElement;

    root?.style.setProperty(
      "--primary-group-change",
      this.state.primaryColor != null ? this.state.primaryColor : ""
    );
    root?.style.setProperty(
      "--secondary-group-change",
      this.state.secondaryColor != null ? this.state.secondaryColor : ""
    );
    root?.style.setProperty(
      "--primary-grey-group-change",
      this.state.grayColor != null ? this.state.grayColor : ""
    );

    const json =
      this.props.json &&
      this.props.json.filter(
        item =>
          !this.state.discipline ||
          item.discipline_id.toString() === this.state.discipline.toString()
      );

    return (
      <>
        {/* {this.props.user.user_roles[0].group_id === 39 ? ( */}
        {this.state.iframe && (
          <Interface
            show={this.state.iframe}
            title={this.state.contentName}
            onClose={() =>
              this.setState({ iframe: false }, () => this.handleActivity())
            }
            aula={this.state.contentId}
            atividade={this.state.activity_id}
            act_item_id={this.state.item_id}
            // act_execution_id={late ? undefined : this.state.execution_id}
            currentRoute={this.props.currentRoute}
            url={!this.state.contentId && this.state.url}
          />
        )}
        <CRow className=" mb-3">
          <CCol xs="12">
            <Breadcrumb current={this.props.currentRoute} />
            <CCard
              style={{
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                height: "calc(98vh - 106px - 4rem)"
              }}
            >
              <CCardHeader className="d-flex justify-content-between align-items-center">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <h4 className="card-title mb-1">Livros</h4>
                  <div className="small text-muted">
                    Veja o livros da biblioteca
                  </div>
                </div>

                <div className="dashboardAlunoOmniSearchBookContainer">
                  <CInputGroup>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Pesquisar conteúdo"
                      onChange={this.handleSearchChange}
                    />
                    <CInputGroupAppend>
                      <CButton color="primary" onClick={this.handleSearchClick}>
                        Pesquisar
                      </CButton>
                    </CInputGroupAppend>
                  </CInputGroup>
                </div>
                <div className="dashboardAlunoOmniSelectBookContainer">
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-book"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CSelect
                      className="flex-1"
                      value={this.state.book ? this.state.book[0].code : null}
                      onChange={e => {
                        const selectedBookId = parseInt(e.target.value);

                        const bookSelected = this.state.books?.find(
                          book => book.id === selectedBookId
                        );

                        this.getBook(e.target.value);

                        // this.setState({
                        //   book: bookSelected,
                        //   chapterSelected: bookSelected?.chapter
                        //     ? bookSelected.chapter
                        //     : null
                        // });
                        // this.loadLos(selectedBookId);
                      }}
                    >
                      <option value={null}>Escolha um livro</option>
                      {this.state.books?.map(book => (
                        <option value={book.code} key={book.id}>
                          {book.code}
                        </option>
                      ))}
                    </CSelect>
                  </CInputGroup>
                </div>
              </CCardHeader>

              <CCardBody className="d-flex p-0">
                <div className="dashboardAlunoOmniLeftBody">
                  {this.state.book?.map(
                    book =>
                      book.chapter && (
                        <div
                          key={book?.chapter}
                          className={`dashboardAlunoOmniLeftBodyItem ${
                            this.state.chapterSelected === book.chapter
                              ? "active"
                              : ""
                          }`}
                          onClick={() => {
                            this.setState({ chapterSelected: book.chapter });
                            // this.loadLos();
                          }}
                        >
                          <p>{book?.chapter}° Capítulo</p>
                          <i className="fa fa-caret-right"></i>
                        </div>
                      )
                  )}
                </div>
                {this.state.loading ? (
                  <Loading></Loading>
                ) : (
                  <div className="DashboardAlunoOmniRightBody">
                    {this.getAbilities()?.map(ability => (
                      <CCard
                        style={{ borderRadius: 0 }}
                        className="mt-0 mb-0"
                        accentColor="primary"
                      >
                        <CCardHeader
                          id="headingOne"
                          className="border-0"
                          onClick={() =>
                            this.setState(state => ({
                              abilitySelected:
                                state.abilitySelected === ability.id
                                  ? null
                                  : ability.id
                            }))
                          }
                        >
                          <CButton
                            block
                            className="text-left m-0 p-0"
                            style={{ boxShadow: "none" }}
                          >
                            <h4
                              className={`m-0 p-0 ${
                                this.state.abilitySelected === ability.id
                                  ? "active"
                                  : ""
                              }`}
                            >
                              {ability.abilities[0].description}
                            </h4>
                          </CButton>
                        </CCardHeader>
                        <CCollapse
                          show={this.state.abilitySelected === ability.id}
                        >
                          <CCardBody>
                            <CRow className="flex-1">
                              {this.state.bookLos?.length > 0 ? (
                                <CCol lg="12">
                                  <div id="leftSide">
                                    <Widgets
                                      itens={this.state.bookLos?.filter(
                                        ab =>
                                          ab.ability_id ===
                                            ability.ability_id &&
                                          ab.chapter ===
                                            this.state.chapterSelected
                                      )}
                                      openItem={this.openItem}
                                      // completionMark
                                    />
                                  </div>
                                </CCol>
                              ) : (
                                <div className="justify-content-center align-items-center d-flex flex-column my-3 w-100">
                                  <img
                                    src={ImgNoData}
                                    style={{
                                      height: "240px",
                                      marginBottom: "2rem"
                                    }}
                                    alt=""
                                  />
                                  <p
                                    style={{ fontSize: "1.5rem" }}
                                    className="mb-2 font-weight-bold text-center"
                                  >
                                    Nenhum conteúdo foi liberado
                                  </p>
                                  <span className="text-muted text-center">
                                    Entre em contato com seu professor
                                  </span>
                                </div>
                              )}
                            </CRow>
                          </CCardBody>
                        </CCollapse>
                      </CCard>
                    ))}
                  </div>
                )}
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DigitalBooksList);
